import {
  NumericInput,
  NumericInputProps,
} from 'components/FormUtils/NumericInput/numeric-input'
import { FieldValues } from 'react-hook-form'
import { cn } from 'components/UI/cn'

export function FilterNumericInput<T extends FieldValues>(
  props: Omit<NumericInputProps<T>, 'getInputClassName'>
) {
  const getFilterClassName = (isFocused: boolean, hasValue: boolean) => {
    return cn({
      '!border !border-brand-active': isFocused, // Active
      '!border !border-brand': !isFocused && hasValue, // Filled
      '!border !border-fg-muted': !isFocused && !hasValue, // Empty
    })
  }

  return <NumericInput {...props} getInputClassName={getFilterClassName} />
}
